import './App.css';
import { Project } from 'commun-cells';
import { useProject } from './hooks/useProject';
import "commun-cells/styles/cells.css";

function App() {
    const { project, config, isLoading, error, reload } = useProject();

    const device_id = config?.device_id;
    const is_local = window.location.hostname.includes('localhost');

    const uri_transformer = (url) => {
        if (is_local) {
            return `/assets/files/${url.split('/').pop()}`;
        } else {
            return url;
        }
    }

    if (isLoading) {
        return (
            <div className="app-loading">
                <div className="loading-spinner"></div>
                <p className="loading-text">Chargement du projet...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="app-error">
                <div className="error-icon">⚠️</div>
                <h2 className="error-title">Erreur de chargement</h2>
                <p className="error-message">{error}</p>
                <button className="error-retry" onClick={reload}>
                    Réessayer
                </button>
            </div>
        );
    }

    if (!project) {
        return (
            <div className="app-error">
                <div className="error-icon">📭</div>
                <h2 className="error-title">Aucun projet</h2>
                <p className="error-message">
                    Configurez le project_id dans config.json
                </p>
            </div>
        );
    }

    const screenSize = {
        width: project.screen_size?.width || window.innerWidth,
        height: project.screen_size?.height || window.innerHeight,
    };

    return (
        <div className="app" style={{
            width: '100vw',
            height: '100vh',
            overflow: 'hidden',
            backgroundColor: '#000',
        }}>
            <Project
                uri_transformer={uri_transformer}
                device_id={device_id}
                project={project} 
                screenSize={screenSize}
                initialPageId={config?.initial_page_id}
                apiUri={config?.api_url}
            />
        </div>
    );
}

export default App;
